import { Boxes } from 'lucide-react';
import { useEntitledToolkits } from '@/hooks/useEntitledToolkits';
import { useT } from '@/lib/i18n';
import { PageTitle } from '@/components/PageTitle';
import { QuickLinkCard } from '@/components/QuickLinkCard';
import { EmptyState } from '@/components/ui/empty-state';

export default function Toolkits() {
  const { t } = useT();
  const toolkits = useEntitledToolkits();

  return (
    <div className="space-y-6">
      <PageTitle title={t('nav.toolkits')} subtitle={t('toolkits.subtitle')} />

      {toolkits.length === 0 ? (
        <EmptyState
          icon={<Boxes className="h-5 w-5" />}
          title={t('toolkits.empty.title')}
          description={t('toolkits.empty.desc')}
        />
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {toolkits.map(tk => (
            <QuickLinkCard
              key={tk.id}
              to={tk.defaultTab ? `${tk.toolkitPath}?tab=${tk.defaultTab}` : tk.toolkitPath}
              icon={<tk.icon className="h-5 w-5" />}
              title={t(tk.labelKey)}
              description={t(tk.descKey)}
              tags={tk.toolkitTabs?.map(tab => t(tab.labelKey))}
            />
          ))}
        </div>
      )}
    </div>
  );
}
